import Controller, { OnBeforeSubmit, OnCancel, OnMount, OnSubmit } from '@philips-internal/oswald-ui-core/lib/client';
import BaseController from '../BaseController';
import { FragmentNames, PaymentItemsAliases } from '../../codegen';
import { DynamicFieldsAPI, FormAPI, Metadata, ModalService } from '@philips-internal/oswald-ui-components';
import { DynamicFieldsType } from '@philips-internal/oswald-ui-constants';
import { Inject } from '@odinjs/odin';
import { AppointmentUtils } from '../../utils/appointment-utils';
import { Value } from '@philips-internal/oswald-ui-core';
import { AbortableSubmitEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { NumberFormatUtils } from '../../utils/number-format-utils';

@Controller({ component: PaymentItemsAliases.PAYMENT_ITEMS_LAYOUT, fragment: FragmentNames.PAYMENT_ITEMS })
class PaymentItemsController extends BaseController {

  @Inject(PaymentItemsAliases.DYNAMIC_FIELDS_PAYMENT_ITEMS)
    paymentDynamicFieldsAPI!: DynamicFieldsAPI;

  @Inject(PaymentItemsAliases.FORM_PAYMENT_ITEMS)
    paymentFormAPI!: FormAPI;

  private dynamicMetadata!: Metadata;

  @OnMount({target: PaymentItemsAliases.FORM_PAYMENT_ITEMS})
  handleMountDynamicFields(): void {
    this.paymentFormAPI.setLoading(true);

    const data = this.context.get('data') as Record<string, unknown>[];

    this.dynamicMetadata = {} as Metadata;
    this.dynamicMetadata.componentType = 'DYNAMIC_FIELDS';
    this.dynamicMetadata.id = 'payment-items-dynamic-fields';
    this.dynamicMetadata.children = [
      {
        children: data.map(item => ({
          children: [],
          componentType: 'FIELD',
          entry: String(item.sequence),
          fieldType: DynamicFieldsType.CHECKBOX,
          id: String(item.sequence),
          label: String(item.description + ' - ') + NumberFormatUtils.formatToCurrentLanguage(Number(item.value)),
        })),
        componentType: 'FIELD_SET',
        entry: 'payment-items-checkbox',
        id: 'input-payment-items-checkbox',
        label: 'patient.procedures',
      },
    ];

    this.paymentDynamicFieldsAPI.setMetadata(this.dynamicMetadata);

    this.paymentFormAPI.setRecord(
      data.reduce<Record<string, Value>>((acc, item) => {
        acc[String(item.sequence)] = true;
        return acc;
      }, {})
    );

    console.log('Payment Items Dynamic Metadata:', this.dynamicMetadata);

    this.paymentFormAPI.setLoading(false);
  }

  @OnBeforeSubmit(PaymentItemsAliases.FORM_PAYMENT_ITEMS)
  onBeforeSubmitForm(event: AbortableSubmitEvent): void {
    const record = event.record as Record<string, Value>;

    if (Object.keys(record).length === 0 || Object.values(record).every(value => !value)) {
      event.abort();
    }
  }

  @OnSubmit(PaymentItemsAliases.FORM_PAYMENT_ITEMS)
  onSubmitForm(): void {
    const data = this.context.get('data') as Record<string, Value>[];
    const record = this.paymentFormAPI.getRecord();
    const params = [] as Record<string, Value>[];

    if (Array.isArray(data)) {
      Object.keys(record).forEach(key => {
        if (record[key]) {
          const paymentItem = data.find((item: Record<string, Value>) => String(item.sequence) === key);
          if (paymentItem) {
            params.push({
              description: paymentItem.description,
              sequence: paymentItem.sequence,
              value: paymentItem.value,
            });
          }
        }
      });
    }

    AppointmentUtils.openPaymentModal(params);
    ModalService.close('payment-items-modal');
  }

  @OnCancel(PaymentItemsAliases.FORM_PAYMENT_ITEMS)
  onCancelForm(): void {
    ModalService.close('payment-items-modal');
  }

}

export default PaymentItemsController;
